module.exports = __webpack_public_path__ + "static/media/csv.7fec78d9.svg";